import { Sparkle28Filled, BotSparkle24Filled } from "@fluentui/react-icons";

export const AnswerIcon = () => {
    return <Sparkle28Filled primaryFill={"#006eb5"} aria-hidden="true" aria-label="Answer logo" />;
};
